import { CircleCheckIcon, InfoIcon, Loader2Icon, OctagonXIcon, TriangleAlertIcon } from "lucide-react";
import { Toaster as Sonner, type ToasterProps } from "sonner";

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme="light"
      richColors
      className="toaster group"
      icons={{
        success: <CircleCheckIcon className="size-4" />,
        info: <InfoIcon className="size-4" />,
        warning: <TriangleAlertIcon className="size-4" />,
        error: <OctagonXIcon className="size-4" />,
        loading: <Loader2Icon className="size-4 animate-spin" />,
      }}
      style={
        {
          "--normal-bg": "var(--color-card)",
          "--normal-text": "var(--color-card-foreground)",
          "--normal-border": "var(--app-border-strong)",
          "--border-radius": "var(--radius)",
          "--success-bg": "#e5faf3",
          "--success-border": "#caf4e6",
          "--success-text": "var(--app-status-success-foreground)",
          "--error-bg": "#ffe6eb",
          "--error-border": "#ffccd6",
          "--error-text": "var(--app-status-danger-foreground)",
          "--info-bg": "var(--normal-bg)",
          "--info-border": "var(--normal-border)",
          "--info-text": "var(--normal-text)",
          "--warning-bg": "var(--normal-bg)",
          "--warning-border": "var(--normal-border)",
          "--warning-text": "var(--normal-text)",
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster };
